var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src && !_vm.loadFailed)?_c('img',_vm._g(_vm._b({directives:[{name:"image-preview",rawName:"v-image-preview"}],attrs:{"loading":"lazy","src":_vm.displaySrc},on:{"error":_vm.onImgError}},'img',_vm.$attrs,false),_vm.forwardListeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }